/**
 * Puente liviano asistente → checkout: memoria de sesión en sessionStorage (misma pestaña).
 * Sin backend.
 */

const STORAGE_KEY = 'soluqr_checkout_chat_ctx_v1';

/**
 * @param {string} businessId
 * @param {{ servicePreference?: string|null, scheduledTime?: string|null, mood?: string|null }|null|undefined} mem
 */
export function persistCheckoutChatContext(businessId, mem) {
  if (!businessId || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        businessId: String(businessId),
        servicePreference: mem?.servicePreference ?? null,
        scheduledTime: mem?.scheduledTime != null ? String(mem.scheduledTime).trim() || null : null,
        mood: mem?.mood ?? null,
        ts: Date.now(),
      })
    );
  } catch {
    // ignore quota / private mode
  }
}

/**
 * @param {string} businessId
 * @returns {{ servicePreference: string|null, scheduledTime: string|null, mood: string|null }|null}
 */
export function readCheckoutChatContext(businessId) {
  if (!businessId || typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || String(o.businessId) !== String(businessId)) return null;
    return {
      servicePreference: o.servicePreference ?? null,
      scheduledTime: o.scheduledTime ?? null,
      mood: o.mood ?? null,
    };
  } catch {
    return null;
  }
}

export function clearCheckoutChatContext() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
